import { ExpenseStatusEnum } from "@finway-group/shared/lib/models"
import { Tag } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

interface ExpenseStatusTagProps {
    status: ExpenseStatusEnum
    isDraft?: boolean
}

export const ExpenseStatusTag = ({ status, isDraft }: ExpenseStatusTagProps) => {
    const { t } = useTranslation()

    const tagClasses = "whitespace-normal break-words leading-tight"

    return (
        <>
            {(() => {
                if (isDraft) {
                    return <Tag className={`ant-tag-yellow ${tagClasses}`}>{t("label:draft")}</Tag>
                }
                switch (status) {
                    case ExpenseStatusEnum.PURCHASE_PENDING:
                        return (
                            <Tag className={`ant-tag-gray ${tagClasses}`} data-testid="finway:purchaseStatusTag:status">
                                {t("label:purchase_pending")}
                            </Tag>
                        )
                    case ExpenseStatusEnum.DOCS_NEEDED:
                        return (
                            <Tag className={`ant-tag-gray ${tagClasses}`} data-testid="finway:purchaseStatusTag:status">
                                {t("label:documents_needed")}
                            </Tag>
                        )
                    case ExpenseStatusEnum.INVOICE_PENDING:
                        return (
                            <Tag className={`ant-tag-gray ${tagClasses}`} data-testid="finway:purchaseStatusTag:status">
                                {t("label:invoice_pending")}
                            </Tag>
                        )
                    case ExpenseStatusEnum.APPROVED:
                        return (
                            <Tag className={`ant-tag-green ${tagClasses}`} data-testid="finway:purchaseStatusTag:status">
                                {t("label:in_review")}
                            </Tag>
                        )
                    case ExpenseStatusEnum.DECLINED:
                        return (
                            <Tag className={`ant-tag-red ${tagClasses}`} data-testid="finway:purchaseStatusTag:status">
                                {t("label:declined")}
                            </Tag>
                        )
                    case ExpenseStatusEnum.REVIEWED:
                        return (
                            <Tag className={`ant-tag-green ${tagClasses}`} data-testid="finway:purchaseStatusTag:status">
                                {t("label:reviewed")}
                            </Tag>
                        )
                    case ExpenseStatusEnum.PAID:
                        return (
                            <Tag className={`ant-tag-green ${tagClasses}`} data-testid="finway:purchaseStatusTag:status">
                                {t("label:paid")}
                            </Tag>
                        )
                    case ExpenseStatusEnum.DONE:
                        return (
                            <Tag className={`ant-tag-green ${tagClasses}`} data-testid="finway:purchaseStatusTag:status">
                                {t("label:exported")}
                            </Tag>
                        )
                    default:
                        return <></>
                }
            })()}
        </>
    )
}
